module.exports = __webpack_public_path__ + "img/ValdrinSahiti.6813ae95.png";